<template>
    <ion-header mode="ios" :class="{'no-height': noHeader}">
        <slot name="header">
            <ion-toolbar class="no-height background-purple-background" />
        </slot>
    </ion-header>

    <ion-content :class="contentClass" v-scrollbar>
        <slot />
    </ion-content>

    <ion-footer v-if="footer">
        <slot name="footer" />
    </ion-footer>
</template>

<script setup lang="ts">
import { IonContent, IonFooter, IonHeader, IonToolbar } from "@ionic/vue";

import { ModalControllerBase } from "@/types/props";

defineProps<ModalControllerBase>()
</script>
